<cap-list-loader [listLoader]="listLoader" [showTotal]="true">
  <div class="cap-list-loader-content">
    <table [attr.aria-label]="'BerechtigtePersonen' | translate" class="cap-table-detail">
      <thead>
        <ng-template [ngTemplateOutlet]="tableHeaders"></ng-template>
      </thead>
      <tbody>
        <ng-template [ngTemplateOutlet]="tableRows"></ng-template>
      </tbody>
    </table>
  </div>
</cap-list-loader>

<ng-template #tableHeaders>
  <tr>
    <th>{{"Personalien" | translate}}</th>
    <th>{{"Rolle" | translate}}</th>
    <th>{{"RechteId" | translate}}</th>
    <th>{{"Grundpfandrecht" | translate}}</th>
    <th>{{"Grundstueck" | translate}}</th>
  </tr>
</ng-template>

<ng-template #tableRows>
  @for (vm of listLoader?.items; track vm; let i = $index) {
    <tr>
      <td>
        @for (g of vm.schuldner; track g; let j = $index) {
          <cap-kompakt-persongb
            [auskunftsperre]="auskunftsperre"
            [capHistinfo]="g.personGb?.histInfo"
            [item]="g.personGb"
            [itemMasterId]="g.personGb.id"></cap-kompakt-persongb>
          @if (g && j < vm.schuldner.length - 1) {
            <br />
          }
        }
      </td>
      <td>
        @for (g of vm.schuldner; track g; let j = $index) {
          <span [capHistinfo]="g.personGb?.histInfo">{{ g.schuldnerrolle.text | translateName }}</span>
          @if (g && j < vm.schuldner.length - 1) {
            <br />
          }
        }
      </td>
      <td [capHistinfo]="vm.pfandrechtVersion.histInfo">
        <cap-link
          [histinfo]="vm.pfandrechtVersion.histInfo"
          [queryParams]="getQueryParams(vm)"
          [target]="navTargets.NAV_RECHT"
          [tooltipParams]="{ art: 'PFANDRECHT' | translate }">
          {{ vm.rechteId | formatRechteId }}
        </cap-link>
      </td>
      <td [capHistinfo]="vm.pfandrechtVersion.histInfo">
        <cap-kompakt-grundpfandrecht
          [histInfo]="vm.pfandrechtVersion.histInfo"
          [masterId]="vm.masterId"
          [rechteId]="vm.rechteId"
          [version]="vm.pfandrechtVersion"></cap-kompakt-grundpfandrecht>
      </td>
      <td>
        @for (b of vm.belastungen; track b; let i = $index) {
          <cap-kompakt-grundstueck
            [capHistinfo]="b.belastung.histInfo"
            [item]="b.belastung.grundstueck"
            [navigateTo]="getDetailNavigation()"></cap-kompakt-grundstueck>
          @if (b && i < vm.belastungen.length - 1) {
            <br />
          }
        }
      </td>
    </tr>
  }
</ng-template>

<ng-template #loading>
  <cap-spinner-small></cap-spinner-small>
</ng-template>
